export default {
  // 判断报警类型 web
  getAlarmType (atype) {
    if (atype === 'nb-co-test') {
      return 'NB一氧化碳测试'
    } else if (atype === 'nb-co') {
      return 'NB一氧化碳报警'
    } else if (atype === 'F-Test') {
      return '烟感自检报警'
    } else if (atype === 'F-Fire') {
      return '烟感火警'
    } else if (atype === 'F-LB') {
      return '烟感低电压报警'
    } else if (atype === 'F-Sensor') {
      return '烟感传感器报警'
    } else if (atype === 'F-Maze') {
      return '烟感迷宫脏'
    } else if (atype === 'C-LB') {
      return '底座低电压报警'
    } else if (atype === 'C-link') {
      return '底座与烟感连接异常报警'
    } else if (atype === 'C-AT') {
      return '底座防拆报警'
    } else if (atype === 'sub_fire') {
      return '烟感'
    } else if (atype === 'sub_co') {
      return '一氧化碳'
    } else if (atype === 'sub_gas') {
      return '燃气'
    } else if (atype === 'sub_keysos') {
      return ' 按钮报警（紧急报警）'
    } else if (atype === 'sub_infrared') {
      return '红外防盗'
    } else if (atype === 'sub_water' || atype === 'water') {
      return '水浸报警'
    } else if (atype === 'sos') {
      return '一键报警'
    } else if (atype === 'sub_lowvoltage') {
      return '子机低电量'
    } else if (atype === 'sub_test') {
      return '烟感测试'
    } else if (atype === 'sub_lowhumidity' || atype === 'humidity-low' || atype === 'aclowhumidity') {
      return '湿度低'
    } else if (atype === 'sub_highhumidity' || atype === 'humidity-high' || atype === 'achighhumidity') {
      return '湿度高'
    } else if (atype === 'sub_lowtemp' || atype === 'temperature-low' || atype === 'aclowtemp') {
      return '温度低'
    } else if (atype === 'sub_hightemp' || atype === 'temperature-high' || atype === 'achightemp') {
      return '温度高'
    } else if (atype === 'achightemp1') {
      return '探头1温度高'
    } else if (atype === 'aclowtemp1') {
      return '探头1温度低'
    } else if (atype === 'achightemp2') {
      return '探头2温度高'
    } else if (atype === 'aclowtemp2') {
      return '探头2温度低'
    } else if (atype === 'achighhumidity1') {
      return '探头1湿度高'
    } else if (atype === 'aclowhumidity1') {
      return '探头1湿度低'
    } else if (atype === 'achighhumidity2') {
      return '探头2湿度高'
    } else if (atype === 'aclowhumidity2') {
      return '探头2湿度低'
    } else if (atype === 'sub_lowlevel') {
      return '水位低'
    } else if (atype === 'sub_highlevel') {
      return '水位高'
    } else if (atype === 'sub_lowpressure') {
      return '水压低'
    } else if (atype === 'sub_highpressure') {
      return '水压高'
    } else if (atype === 'sub_closedoor' || atype === 'doorclose' || atype === 'lockclosedoor' || atype === 'sub_door_close' || atype === 'door-close') {
      return '关门'
    } else if (atype === 'sub_opendoor' || atype === 'dooropen' || atype === 'lockopendoor' || atype === 'sub_door_open' || atype === 'door-open') {
      return '开门'
    } else if (atype === 'c-at') {
      return '拆开'
    } else if (atype === 'sub_fire_test') {
      return '子机烟感测试'
    } else if (atype === 'f-fire') {
      return '烟雾报警'
    } else if (atype === 'f-lb' || atype === 'lowbattery') {
      return '低电量报警'
    } else if (atype === 'F-Heart') {
      return '心跳/恢复正常'
    } else if (atype === 'C-At') {
      return '拆除'
    } else if (atype === 'f-test' || atype === 'test') {
      return '测试'
    } else if (atype === 'f-sensor') {
      return '故障'
    } else if (atype === 'F-Temp' || atype === 'achighttemp' || atype === 'actemp' || atype === 'achightemp') {
      return '温度报警'
    } else if (atype === 'sos_test') {
      return '测试一键报警测试'
    } else if (atype === 'sys_isactivity') {
      return '活动监测警报'
    } else if (atype === 'poweroff') {
      return '关机'
    } else if (atype === 'poweron') {
      return '开机'
    } else if (atype === 'lockrequsetopendoor') {
      return '请求开锁'
    } else if (atype === 'sendopenlock') {
      return '开锁授权'
    } else if (atype === 'acoff') {
      return '断电'
    } else if (atype === 'acon') {
      return '上电'
    } else if (atype === 'sub_door_open,sub_door_close') {
      return '开门&关门报警'
    } else if (atype === 'wifilock_open') {
      return '开锁'
    } else if (atype === 'wifilock_close') {
      return '关锁'
    } else if (atype === 'outage') {
      return '防拆'
    } else if (atype === 'no_active_alarm') {
      return '无活动报警'
    } else if (atype === 'stranded_alarm' || atype === 'residence_alarm') {
      return '滞留报警'
    } else if (atype === 'human_exist') {
      return '有人'
    } else if (atype === 'human_not_exist') {
      return '无人'
    } else if (atype === 'sub_keysos') {
      return '子机按钮报警'
    } else if (atype === 'sub_keysos_alarm') {
      return '紧急按钮报警'
    } else if (atype === 'sub_keysos_test') {
      return '紧急按钮测试'
    } else if (atype === 'batterylowvoltage') {
      return '电池电压低'
    } else if (atype === 'switchbattery') {
      return '切换电池供电'
    } else if (atype === 'switchexternalpower') {
      return '正在外部供电'
    } else if (atype === 'fall') {
      return '跌倒'
    } else if (atype === 'vibration') {
      return '振动'
    } else if (atype === 'battery-low') {
      return '电量低'
    } else {
      return atype
    }
  },
  GetDateStr (AddDayCount, time) {
    let dd = new Date(time)
    dd.setDate(dd.getDate() + AddDayCount)// 获取AddDayCount天后的日期 负数为前N天 正数为后N天
    let date = dd.Format('yyyy-MM-dd')
    return date
  },
  // 主设备icon
  getDeviceImg () {
    let arr = [
      {dtype: 300, imgUrl: 'static/alarmList/list_shoubiao.png'}, // 2G手表
      {dtype: 99, imgUrl: 'static/newDeviceIcon/index_smoke.png'}, // nb烟感
      {dtype: 200, imgUrl: 'static/newDeviceIcon/index_police.png'}, // 一键报警
      {dtype: 800, imgUrl: 'static/newDeviceIcon/index_police_gateway.png'}, // 一键报警网关 (网关)
      {dtype: 503, imgUrl: 'static/newDeviceIcon/index_fire.png'}, // 灭火器压力表

      {dtype: 700, imgUrl: 'static/newDeviceIcon/index_gateway.png'}, // 安防智能网关 (网关)
      {dtype: 400, imgUrl: 'static/newDeviceIcon/index_lock.png'}, // 门锁 (网关)
      {dtype: 501, imgUrl: 'static/newDeviceIcon/index_CO.png'}, // 一氧化碳
      {dtype: 502, imgUrl: 'static/newDeviceIcon/index_gas.png'}, // 燃气
      {dtype: 505, imgUrl: 'static/newDeviceIcon/index_SOS_btn.png'}, // NB-SOS按钮 巡鹰
      {dtype: 504, imgUrl: 'static/newDeviceIcon/index_door_sensor.png'}, // NB门磁
      {dtype: 902, imgUrl: 'static/newDeviceIcon/index_701SE.png'}, // Cat1 拉绳报警器
      {dtype: 506, imgUrl: 'static/newDeviceIcon/index_smoke.png'}, // NB-烟感新
      {dtype: 507, imgUrl: 'static/newDeviceIcon/index_SOS_btn.png'}, // NB-SOS按钮 西美
      {dtype: 537, imgUrl: 'static/newDeviceIcon/index_SOS_btn.png'}, // 4G-SOS按钮 西美
      {dtype: 508, imgUrl: 'static/newDeviceIcon/index_door_sensor.png'}, // NB门磁（新模块）
      {dtype: 538, imgUrl: 'static/newDeviceIcon/index_door538.png'}, // 4G门磁（新模块）
      {dtype: 509, imgUrl: 'static/alarmList/list_lock_nb.png'}, // 门锁 (NB)
      {dtype: 510, imgUrl: 'static/newDeviceIcon/nb_water.png'}, // NB水浸 西美
      {dtype: 511, imgUrl: 'static/newDeviceIcon/ac_device.png'}, // AC断电监测 西美
      {dtype: 512, imgUrl: 'static/newDeviceIcon/index_smoke.png'}, // NB烟感 西美
      {dtype: 401, imgUrl: 'static/newDeviceIcon/index_lock.png'}, // 门锁
      {dtype: 901, imgUrl: 'static/newDeviceIcon/index_W23.png'}, // Cat1 W23
      {dtype: 40123, imgUrl: 'static/newDeviceIcon/index_door_sensor.png'}, // NB门磁
      {dtype: 402, imgUrl: 'static/newDeviceIcon/index_door402.png'}, // wifi门磁
      {dtype: 403, imgUrl: 'static/newDeviceIcon/nb_water.png'}, // wifi水浸
      {dtype: 903, imgUrl: 'static/newDeviceIcon/index_W23.png'}, // Cat1 W23
      {dtype: 404, imgUrl: 'static/newDeviceIcon/index_door404.png'}, // wifi门磁
      {dtype: 904, imgUrl: 'static/newDeviceIcon/index_904.png'}, // 电信平台 cat1 断电报警设备
      {dtype: 905, imgUrl: 'static/newDeviceIcon/index_904.png'}, // 移动平台 cat1 断电报警设备
      {dtype: 906, imgUrl: 'static/newDeviceIcon/index_ups.png'}, // UPS设备906
      {dtype: 920, imgUrl: 'static/newDeviceIcon/index_ups920.png'}, // UPS设备920
      {dtype: 350, imgUrl: 'static/newDeviceIcon/index_shoubiao.png'}, // 手表
      {dtype: 310, imgUrl: 'static/newDeviceIcon/index_shoubiao.png'}, // 手表
      {dtype: 311, imgUrl: 'static/newDeviceIcon/index_shoubiao.png'}, // 手表
      {dtype: 312, imgUrl: 'static/newDeviceIcon/index_shoubiao312.png'}, // 手表0
      {dtype: 301, imgUrl: 'static/newDeviceIcon/index_gps.png'}, // 定位器
      {dtype: 751, imgUrl: 'static/newDeviceIcon/index_wenshidu.png'}, // 温湿度
      {dtype: 753, imgUrl: 'static/newDeviceIcon/index_wenshidu753.png'}, // 4G温湿度
      {dtype: 330, imgUrl: 'static/newDeviceIcon/index_watch_bsj.png'}, // 4G手表-BSJ
      {dtype: 331, imgUrl: 'static/newDeviceIcon/index_701SE.png'}, // 4G拉绳报警器-BSJ
      {dtype: 332, imgUrl: 'static/newDeviceIcon/index_watch_bsj332.png'}, // 手表-BSJ
      {dtype: 752, imgUrl: 'static/newDeviceIcon/index_rader752.png'}, // 4G存在感应雷达752
      {dtype: 780, imgUrl: 'static/newDeviceIcon/index_rader780.png'}, // 4G跌倒雷达780
      {dtype: 408, imgUrl: 'static/newDeviceIcon/index_rader780.png'}, // wifi跌倒雷达408
      {dtype: 701, imgUrl: 'static/newDeviceIcon/index_701SE1.png'}, // 701拉绳网关
      {dtype: 543, imgUrl: 'static/newDeviceIcon/index_door402.png'}, // 4G门磁(布撤防状态)
      {dtype: 544, imgUrl: 'static/newDeviceIcon/nb_water.png'}, // 4G水浸(布撤防状态)
      {dtype: 313, imgUrl: 'static/newDeviceIcon/index_shoubiao.png'}, // 4G健康手表
      {dtype: 351, imgUrl: 'static/newDeviceIcon/index_shoubiao.png'}, // 防拆手表
      {dtype: 352, imgUrl: 'static/newDeviceIcon/index_shoubiao.png'}, // 防拆手表
      {dtype: 353, imgUrl: 'static/newDeviceIcon/index_shoubiao.png'}, // 防拆手表
      {dtype: 601, imgUrl: 'static/newDeviceIcon/index_lock.png'}, // 4G智能门锁
      {dtype: 613, imgUrl: 'static/newDeviceIcon/index_lock.png'}, // 4G智能门锁
      {dtype: '', imgUrl: 'static/newDeviceIcon/index_default.png'} // 默认
    ]
    return arr
  },
  // 子机设备icon
  getSubDeviceImg () {
    let arr = [
      {dtype: 1, imgUrl: 'static/newDeviceIcon/index_CO.png'}, // 一氧化碳

      {dtype: 2, imgUrl: 'static/newDeviceIcon/index_humiture_smoke.png'}, // 烟感
      {dtype: 12, imgUrl: 'static/newDeviceIcon/index_water.png'}, // 水压
      {dtype: 13, imgUrl: 'static/newDeviceIcon/index_level.png'}, // 水位
      {dtype: 51, imgUrl: 'static/newDeviceIcon/index_socket.png'}, // 智能开关
      {dtype: 52, imgUrl: 'static/newDeviceIcon/index_humiture.png'}, // 温湿度
      {dtype: 53, imgUrl: 'static/newDeviceIcon/second_lamp.png'}, // 智能灯泡
      {dtype: 11, imgUrl: 'static/newDeviceIcon/index_humiture_smoke.png'}, // 温湿度烟感
      {dtype: -1, imgUrl: 'static/newDeviceIcon/second_alarmlamp.png'}, // 警灯
      {dtype: 3, imgUrl: 'static/newDeviceIcon/index_gas.png'}, // 燃气
      {dtype: 4, imgUrl: 'static/newDeviceIcon/second_door.png'}, // 门磁
      {dtype: 5, imgUrl: 'static/newDeviceIcon/second_doorbell.png'}, // 门铃
      {dtype: 6, imgUrl: 'static/newDeviceIcon/second_red.png'}, // 红外
      {dtype: 7, imgUrl: 'static/newDeviceIcon/second_water.png'}, // 水浸
      {dtype: 8, imgUrl: 'static/newDeviceIcon/second_control.png'}, // 遥控器
      {dtype: 14, imgUrl: 'static/newDeviceIcon/second_door.png'}, // 门磁
      {dtype: 15, imgUrl: 'static/newDeviceIcon/second_radar.png'}, // 雷达（存在感应）
      {dtype: 16, imgUrl: 'static/newDeviceIcon/index_SOS_btn.png'}, // 433 fsk 紧急按钮
      {dtype: '', imgUrl: 'static/newDeviceIcon/index_default.png'} // 默认
    ]
    return arr
  },
  // 报警设备icon
  getAlamImg () {
    let arr = [
      {dtype: 300, imgUrl: 'static/alarmList/list_shoubiao.png'}, // 2G手表
      {dtype: 99, imgUrl: 'static/alarmList/list_smoke.png'}, // nb烟感
      {dtype: 200, imgUrl: 'static/alarmList/list_police.png'}, // 一键报警
      {dtype: 800, imgUrl: 'static/alarmList/list_police_gateway.png'}, // 一键报警网关 (网关)
      {dtype: 503, imgUrl: 'static/alarmList/list_fire.png'}, // 灭火器压力表

      {dtype: 700, imgUrl: 'static/alarmList/list_gateway.png'}, // 安防智能网关 (网关)
      {dtype: 400, imgUrl: 'static/alarmList/index_lock.png'}, // 门锁 (网关)
      {dtype: 501, imgUrl: 'static/alarmList/list_CO.png'}, // 一氧化碳
      {dtype: 502, imgUrl: 'static/alarmList/list_gas.png'}, // 燃气
      {dtype: 505, imgUrl: 'static/alarmList/list_SOS_btn.png'}, // NB-SOS按钮 巡鹰
      {dtype: 504, imgUrl: 'static/alarmList/list_door_sensor.png'}, // NB门磁
      {dtype: 902, imgUrl: 'static/alarmList/list_701SE.png'}, // Cat1 拉绳报警器
      {dtype: 506, imgUrl: 'static/alarmList/list_smoke.png'}, // NB-烟感新
      {dtype: 507, imgUrl: 'static/alarmList/list_SOS_btn.png'}, // NB-SOS按钮 西美
      {dtype: 537, imgUrl: 'static/alarmList/list_SOS_btn.png'}, // 4G-SOS按钮 西美
      {dtype: 508, imgUrl: 'static/newDeviceIcon/index_door_sensor.png'}, // NB门磁（新模块）
      {dtype: 538, imgUrl: 'static/newDeviceIcon/index_door538.png'}, // 4G门磁（新模块）
      {dtype: 509, imgUrl: 'static/alarmList/list_lock_nb.png'}, // 门锁 (NB)
      {dtype: 510, imgUrl: 'static/newDeviceIcon/nb_water.png'}, // NB水浸 西美
      {dtype: 511, imgUrl: 'static/newDeviceIcon/ac_device.png'}, // ac断电监测 西美
      {dtype: 512, imgUrl: 'static/alarmList/list_smoke.png'}, // NB烟感 西美
      {dtype: 401, imgUrl: 'static/newDeviceIcon/index_lock.png'}, // 门锁
      {dtype: 901, imgUrl: 'static/alarmList/list_W23.png'}, // Cat1 W23
      {dtype: 40123, imgUrl: 'static/alarmList/list_door_sensor.png'}, // NB门磁
      {dtype: 402, imgUrl: 'static/alarmList/list_door402.png'}, // wifi门磁
      {dtype: 403, imgUrl: 'static/newDeviceIcon/nb_water.png'}, // wifi水浸
      {dtype: 903, imgUrl: 'static/newDeviceIcon/list_W23.png'}, // Cat1 W23
      {dtype: 404, imgUrl: 'static/alarmList/list_door404.png'}, // wifi门磁
      {dtype: 904, imgUrl: 'static/alarmList/list_904.png'}, // 电信平台 cat1 断电报警设备
      {dtype: 905, imgUrl: 'static/alarmList/list_904.png'}, // 移动平台 cat1 断电报警设备
      {dtype: 906, imgUrl: 'static/alarmList/list_ups.png'}, // UPS设备906
      {dtype: 920, imgUrl: 'static/alarmList/list_ups920.png'}, // UPS设备920
      {dtype: 350, imgUrl: 'static/alarmList/list_shoubiao.png'}, // 手表
      {dtype: 310, imgUrl: 'static/alarmList/list_shoubiao.png'}, // 手表
      {dtype: 311, imgUrl: 'static/alarmList/list_shoubiao.png'}, // 手表
      {dtype: 312, imgUrl: 'static/alarmList/list_shoubiao312.png'}, // 手表
      {dtype: 301, imgUrl: 'static/alarmList/list_gps.png'}, // 定位器
      {dtype: 751, imgUrl: 'static/alarmList/list_wenshidu.png'}, // 温湿度
      {dtype: 753, imgUrl: 'static/alarmList/list_wenshidu753.png'}, // 4G温湿度753
      {dtype: 330, imgUrl: 'static/alarmList/list_shoubiao_bsj.png'}, // 4G手表-BSJ
      {dtype: 331, imgUrl: 'static/alarmList/list_701SE.png'}, // 4G拉绳报警器-BSJ
      {dtype: 332, imgUrl: 'static/alarmList/list_shoubiao_bsj332.png'}, // 手表-BSJ
      {dtype: 752, imgUrl: 'static/alarmList/list_rander752.png'}, // 4G存在感应雷达752
      {dtype: 780, imgUrl: 'static/alarmList/list_rander780.png'}, // 4G跌倒雷达780
      {dtype: 408, imgUrl: 'static/alarmList/list_rander780.png'}, // wifi跌倒雷达408
      {dtype: 701, imgUrl: 'static/alarmList/list_701SE1.png'}, // 701拉绳网关
      {dtype: 543, imgUrl: 'static/alarmList/list_door402.png'}, // 4G门磁(布撤防状态)
      {dtype: 544, imgUrl: 'static/newDeviceIcon/nb_water.png'}, // 4G水浸(布撤防状态)
      {dtype: 545, imgUrl: 'static/alarmList/list_infrared4g.png'}, // 4G红外
      // 子机首页
      {dtype: 1, imgUrl: 'static/alarmList/list_CO.png'}, // 一氧化碳

      {dtype: 2, imgUrl: 'static/alarmList/list_humiture_smoke.png'}, // 烟感
      {dtype: 12, imgUrl: 'static/alarmList/list_watergage.png'}, // 水压
      {dtype: 13, imgUrl: 'static/alarmList/list_level.png'}, // 水位
      {dtype: 51, imgUrl: 'static/alarmList/list_socket.png'}, // 智能开关
      {dtype: 52, imgUrl: 'static/alarmList/list_humiture.png'}, // 温湿度
      {dtype: 53, imgUrl: 'static/alarmList/list_lamp.png'}, // 智能灯泡
      {dtype: 11, imgUrl: 'static/alarmList/list_humiture_smoke.png'}, // 温湿度烟感
      {dtype: -1, imgUrl: 'static/alarmList/list_alarmlamp.png'}, // 警灯
      {dtype: 3, imgUrl: 'static/alarmList/list_gas.png'}, // 燃气
      {dtype: 4, imgUrl: 'static/alarmList/list_door_sensor.png'}, // 门磁
      {dtype: 5, imgUrl: 'static/alarmList/list_doorbell.png'}, // 门铃
      {dtype: 6, imgUrl: 'static/alarmList/list_red.png'}, // 红外
      {dtype: 7, imgUrl: 'static/alarmList/list_second_water.png'}, // 水浸
      {dtype: 8, imgUrl: 'static/alarmList/list_control.png'}, // 遥控器
      {dtype: 14, imgUrl: 'static/alarmList/list_door_sensor.png'}, // 门磁
      {dtype: 15, imgUrl: 'static/newDeviceIcon/second_radar.png'}, // 雷达（存在感应）
      {dtype: 16, imgUrl: 'static/newDeviceIcon/index_SOS_btn.png'}, // 433 fsk 紧急按钮
      {dtype: '', imgUrl: 'static/alarmList/list_default_father.png'} // 默认
    ]
    return arr
  },
  // 添加设备icon
  getAddImg () {
    let arr = [
      {dtype: 300, imgUrl: 'static/addDevice/add_shoubiao.png'}, // 2G手表
      {dtype: 99, imgUrl: 'static/addDevice/add_smoke.png'}, // nb烟感
      {dtype: 200, imgUrl: 'static/addDevice/add_police.png'}, // 一键报警
      {dtype: 800, imgUrl: 'static/addDevice/add_police_gateway.png'}, // 一键报警网关 (网关)
      {dtype: 503, imgUrl: 'static/addDevice/add_fire.png'}, // 灭火器压力表

      {dtype: 700, imgUrl: 'static/addDevice/add_gateway.png'}, // 安防智能网关 (网关)
      {dtype: 400, imgUrl: 'static/addDevice/add_lock.png'}, // 门锁 (网关)
      {dtype: 501, imgUrl: 'static/addDevice/add_CO.png'}, // 一氧化碳
      {dtype: 502, imgUrl: 'static/addDevice/add_gas.png'}, // 燃气
      {dtype: 505, imgUrl: 'static/addDevice/add_equipment_SOS_btn.png'}, // NB-SOS按钮 巡鹰
      {dtype: 504, imgUrl: 'static/addDevice/add_door_sensor.png'}, // NB门磁
      {dtype: 902, imgUrl: 'static/addDevice/add_701SE.png'}, // Cat1 拉绳报警器
      {dtype: 506, imgUrl: 'static/addDevice/add_smoke.png'}, // NB-烟感新
      {dtype: 507, imgUrl: 'static/addDevice/add_equipment_SOS_btn.png'}, // NB-SOS按钮 西美
      {dtype: 537, imgUrl: 'static/addDevice/add_equipment_SOS_btn.png'}, // 4G-SOS按钮 西美
      {dtype: 508, imgUrl: 'static/addDevice/add_door_sensor.png'}, // NB门磁（新模块）
      {dtype: 538, imgUrl: 'static/addDevice/add_door538.png'}, // 4G门磁（新模块）
      {dtype: 509, imgUrl: 'static/addDevice/add_lock_nb.png'}, // 门锁 (NB)
      {dtype: 510, imgUrl: 'static/addDevice/add_nb_water.png'}, // NB水浸 西美
      {dtype: 511, imgUrl: 'static/addDevice/add_ac.png'}, // AC断电监测 西美
      {dtype: 512, imgUrl: 'static/addDevice/add_smoke.png'}, // NB烟感 西美
      {dtype: 401, imgUrl: 'static/addDevice/add_lock.png'}, // 门锁
      {dtype: 901, imgUrl: 'static/addDevice/add_equipment_W23.png'}, // Cat1 W23
      {dtype: 40123, imgUrl: 'static/addDevice/add_door_sensor.png'}, // NB门磁
      {dtype: 402, imgUrl: 'static/addDevice/add_door402.png'}, // wifi门磁
      {dtype: 403, imgUrl: 'static/addDevice/add_nb_water.png'}, // wifi水浸
      {dtype: 404, imgUrl: 'static/addDevice/add_door404.png'}, // wifi门磁
      {dtype: 904, imgUrl: 'static/addDevice/add_904.png'}, // 电信平台 cat1 断电报警设备
      {dtype: 905, imgUrl: 'static/addDevice/add_904.png'}, // 移动平台 cat1 断电报警设备
      {dtype: 906, imgUrl: 'static/addDevice/add_ups.png'}, // UPS设备906
      {dtype: 920, imgUrl: 'static/addDevice/add_ups920.png'}, // UPS设备920
      {dtype: 350, imgUrl: 'static/addDevice/add_shoubiao.png'}, // 手表
      {dtype: 310, imgUrl: 'static/addDevice/add_shoubiao.png'}, // 手表
      {dtype: 311, imgUrl: 'static/addDevice/add_shoubiao.png'}, // 手表
      {dtype: 312, imgUrl: 'static/addDevice/add_shoubiao312.png'}, // 手表
      {dtype: 301, imgUrl: 'static/addDevice/add_gps.png'}, // 定位器
      {dtype: 751, imgUrl: 'static/addDevice/add_wenshidu.png'}, // 温湿度
      {dtype: 753, imgUrl: 'static/addDevice/add_wenshidu753.png'}, // 4G温湿度
      {dtype: 330, imgUrl: 'static/addDevice/add_shoubiao_bsj.png'}, // 4G手表-BSJ
      {dtype: 331, imgUrl: 'static/addDevice/add_701SE.png'}, //  4G拉绳报警器-BSJ
      {dtype: 332, imgUrl: 'static/addDevice/add_shoubiao_bsj332.png'}, // 手表-BSJ332
      {dtype: 752, imgUrl: 'static/addDevice/add_rader752.png'}, // 4G存在感应雷达752
      {dtype: 780, imgUrl: 'static/addDevice/add_rader780.png'}, // 4G存在感应雷达780
      {dtype: 408, imgUrl: 'static/addDevice/add_rader780.png'}, // wifi存在感应雷达408
      {dtype: 701, imgUrl: 'static/addDevice/add_701SE1.png'}, // 701拉绳网关
      {dtype: 543, imgUrl: 'static/addDevice/add_door402.png'}, // 4G门磁(布撤防状态)
      {dtype: 544, imgUrl: 'static/addDevice/add_nb_water.png'}, // 4G水浸(布撤防状态)
      {dtype: 545, imgUrl: 'static/addDevice/add_infrared4g.png'}, // 4G红外
      {dtype: '', imgUrl: 'static/newDeviceIcon/index_default.png'} // 默认
    ]
    return arr
  },
  // 判断是否为蜂窝/4G/2G流量卡白名单设备（纳入流量卡管理）
  isCellularTrafficCard (dtype) {
    if (!dtype) return false
    let t = Number(dtype)
    // 子机 (< 100) 排除
    if (t < 100) return false
    // 蜂窝设备白名单
    let cellularTypes = [
      300, 301,
      310, 311, 312, 313,
      330, 331, 332,
      350, 351, 352, 353,
      533, 534, 536, 537, 538, 539, 540, 541, 542, 543, 544, 545, 546,
      601, 613,
      700, 701,
      750, 751, 752, 753, 754,
      780,
      800,
      850, 851, 852,
      901, 902, 903, 904, 905, 906,
      920
    ]
    return cellularTypes.indexOf(t) !== -1
  },
  // 判断是否为不需要流量卡管理的设备（子机、WiFi、NB设备等）
  isNbOrNon4G (dtype) {
    return !this.isCellularTrafficCard(dtype)
  }
}



// WEBPACK FOOTER //
// ./src/common/common.js